export const getBooleanSearchParam = (
  searchParams: URLSearchParams,
  paramName: string,
): boolean => {
  const param = searchParams.get(paramName);
  return param === 'true';
};

export function getStringArraySearchParam(
  searchParams: URLSearchParams,
  key: string,
): string[] {
  const param = searchParams.get(key);
  return param ? param.split(',') : [];
}

export const toggleParam = (
  value: string | number,
  currentValues: string[],
  allValues: string[],
  paramKey: string,
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams) => void,
) => {
  const valueString = String(value);

  const newSearchParams = new URLSearchParams(searchParams);
  const currentSet = new Set(currentValues);

  if (currentSet.has(valueString)) {
    currentSet.delete(valueString);
  } else {
    currentSet.add(valueString);
  }

  const updatedValues = Array.from(currentSet);

  const isSelectAll =
    allValues.length && allValues.every((val) => currentSet.has(val));

  if (!updatedValues.length || isSelectAll) {
    newSearchParams.delete(paramKey);
  } else {
    newSearchParams.set(paramKey, updatedValues.join(','));
  }

  setSearchParams(newSearchParams);
};

export const getChainIdFromQuery = (
  filter: string | null,
): number | undefined => {
  if (!filter) return undefined;

  try {
    const decodedValue = decodeURIComponent(filter);
    const parsedValue = JSON.parse(decodedValue);

    if (
      Array.isArray(parsedValue) &&
      parsedValue.every((item) => typeof item === 'number')
    ) {
      return parsedValue[0];
    }

    return undefined;
  } catch (error) {
    return undefined;
  }
};
